export default __webpack_public_path__ + "static/media/email.7fed6d01.svg";